import StorageMartStorageCalculator from './StorageMartStorageCalculator';

export default StorageMartStorageCalculator;
export { ID, NAME } from './properties';
